import { ChromeActionsDock } from "../ChromeActions";
// The sidebar's bottom dock (NAVBAR_REMOVAL_PLAN.md §2): the five chrome
// actions that lived on the removed GS navbar. Mounted by MainLeftSidebar as
// a flex-shrink-0 sibling AFTER the flex-1 scroll tree — inside the tree it
// would scroll away with it. GS only; DD keeps its navbar and gets no dock.
const SidebarDock = () => (
  <div className="flex-shrink-0 border-t border-mainDivider px-2.5 py-2">
    <div className="flex items-center justify-center gap-x-3">
      <ChromeActionsDock />
    </div>
  </div>
);
export default SidebarDock;
